"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleErrorDetails = exports.constructErrorMessaging = exports.formatDate = exports.getBrowserLocale = exports.formatNumber = exports.constructCityStateZip = exports.constructNeighborhood = exports.constructPropertyName = exports.constructUrlWithParams = exports.dedupSearchParams = exports.parseLocationSearch = exports.initializeAuthInterceptor = exports.parseSiteExperience = exports.SiteExp = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const parseISO_1 = __importDefault(require("date-fns/parseISO"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const Constants_1 = require("./Constants");
var SiteExp;
(function (SiteExp) {
    SiteExp["HOLDINGS"] = "holdings";
    SiteExp["INVESTORS"] = "investors";
    SiteExp["LANDING"] = "landing";
    SiteExp["RENTALS"] = "rentals";
    SiteExp["TENANTS"] = "tenants";
})(SiteExp = exports.SiteExp || (exports.SiteExp = {}));
/**
 * @param siteExp - type of SiteExp
 * @param config - type of SiteExperienceDomainInterface
 */
const parseSiteExperience = (siteExp, config) => {
    switch (siteExp) {
        case SiteExp.HOLDINGS:
            return config.holdings.baseUrl;
        case SiteExp.INVESTORS:
            return config.investors.baseUrl;
        case SiteExp.RENTALS:
            return config.rentals.baseUrl;
        case SiteExp.TENANTS:
            return config.tenants.baseUrl;
        case SiteExp.LANDING:
            return config.landing.baseUrl;
        default:
            return config.id.baseUrl;
    }
};
exports.parseSiteExperience = parseSiteExperience;
/**
 * @param apiClient - instance of Axios from application
 * @param redirectUrl - url to redirect to (needs to be absolute)
 * @param cookieProps - name & domain of cookie
 */
const initializeAuthInterceptor = (apiClient, redirectUrl, cookieProps, statusCode = 401) => {
    const { name, domain } = cookieProps;
    apiClient.interceptors.response.onFulfilled = (response) => {
        if (response.status === statusCode) {
            js_cookie_1.default.remove(name, { domain });
            setTimeout(() => (window.location.href = redirectUrl), 100);
        }
        return response;
    };
};
exports.initializeAuthInterceptor = initializeAuthInterceptor;
/**
 * @param search - string of search params
 * Returns an object of search params for easier usage
 */
const parseLocationSearch = (string) => {
    const result = {};
    const str = String(string); // needed for server side rendering
    if (str.length === 0)
        return result;
    const args = str.substring(1).split('&');
    let i;
    let arg;
    let kvp;
    let key;
    let value;
    for (i = 0; i < args.length; i++) {
        arg = args[i];
        if (arg.indexOf('=') === -1) {
            result[decodeURIComponent(arg).trim()] = true;
        }
        else {
            kvp = arg.split('=');
            key = decodeURIComponent(kvp[0]).trim();
            value = decodeURIComponent(kvp[1]).trim();
            result[key] = value;
        }
    }
    return result;
};
exports.parseLocationSearch = parseLocationSearch;
/**
 * @param params - string of params
 * @param options - persistList of params. Allows application to have an expanded set of params to persist.
 * Returns a formatted string of params that are deduped and validated against with an allow list of persisted params.
 */
const dedupSearchParams = (params, options) => {
    var _a, _b, _c;
    const currentParams = (0, exports.parseLocationSearch)((_c = (_b = (_a = global.window) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.search) !== null && _c !== void 0 ? _c : {});
    const incomingParams = params.length > 0 ? (0, exports.parseLocationSearch)(`?${params}`) : {};
    let allowList = Constants_1.ParamAllowList;
    if (options === null || options === void 0 ? void 0 : options.persistList)
        allowList = allowList.concat(options.persistList);
    const persistAllowedParams = {};
    Object.keys(currentParams).forEach((key) => {
        if (allowList.includes(key))
            persistAllowedParams[key] = currentParams[key];
    });
    const mergedParams = Object.assign(Object.assign({}, persistAllowedParams), incomingParams);
    const strParams = Object.entries(mergedParams)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');
    return strParams.length > 0 ? `?${strParams}` : '';
};
exports.dedupSearchParams = dedupSearchParams;
/**
 * @param url - URL to return with constructed params
 * @param options - optional. consists of persistList that can be passed in to allow an expanded list of the persisted params
 */
const constructUrlWithParams = (url, options) => {
    const [pathname, search = ''] = url.split('?');
    return `${pathname}${(0, exports.dedupSearchParams)(search, options)}`;
};
exports.constructUrlWithParams = constructUrlWithParams;
/**
 * construct a property name from the address
 * "primary_number street"
 * @param address
 */
const constructPropertyName = (address) => {
    return `${address.primary_number} ${address.street}`;
};
exports.constructPropertyName = constructPropertyName;
/**
 * Construct Neighborhood from Address
 * If neighborhood does not exist, returns city
 * @param address
 */
const constructNeighborhood = (address) => {
    return address.neighborhood && address.neighborhood.length > 0 ? address.neighborhood : address.city;
};
exports.constructNeighborhood = constructNeighborhood;
/**
 * Construct City, State Zip line
 * @param address
 */
const constructCityStateZip = (address) => {
    return `${address.city}, ${address.state} ${address.zipcode}`;
};
exports.constructCityStateZip = constructCityStateZip;
/**
 * Used for Formatting Numbers
 * @param value: string | number
 * @param options: FormatMessageOptions which extends from Intl.NumberFormat
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options)
 */
const formatNumber = (value, options = {}) => {
    var _a, _b;
    const { locale = (0, exports.getBrowserLocale)((_b = (_a = global === null || global === void 0 ? void 0 : global.window) === null || _a === void 0 ? void 0 : _a.navigator.language) !== null && _b !== void 0 ? _b : Constants_1.LocaleCode.en_us), decimals = 0 } = options, remainingOptions = __rest(options, ["locale", "decimals"]);
    const style = options.currency ? 'currency' : options.style;
    return Intl.NumberFormat(locale, Object.assign({ maximumFractionDigits: decimals, minimumFractionDigits: decimals, style }, remainingOptions)).format(value);
};
exports.formatNumber = formatNumber;
/**
 * Get Locale from Browser Language
 * returns a locale code that matches (to the language level) of the language code
 * @param lang
 */
const getBrowserLocale = (lang) => {
    var _a, _b;
    const normalizedLang = lang
        ? lang.toLowerCase()
        : (0, exports.getBrowserLocale)((_b = (_a = global === null || global === void 0 ? void 0 : global.window) === null || _a === void 0 ? void 0 : _a.navigator.language) !== null && _b !== void 0 ? _b : Constants_1.LocaleCode.en_us).toLowerCase();
    let locale;
    const getLocale = (value) => {
        switch (value) {
            // specific locale codes
            case Constants_1.LocaleCode.en_us:
                locale = Constants_1.LocaleCode.en_us;
                break;
            case Constants_1.LocaleCode.es_es:
                locale = Constants_1.LocaleCode.es_es;
                break;
            // Specific language codes
            case Constants_1.BrowserLanguage.en:
                locale = Constants_1.LocaleCode.en_us;
                break;
            case Constants_1.BrowserLanguage.es:
                locale = Constants_1.LocaleCode.es_es;
                break;
            default:
                locale = undefined;
                break;
        }
    };
    // check for full locale
    getLocale(normalizedLang);
    // check for language fallback
    if (!locale)
        getLocale(normalizedLang.split('-')[0]);
    // if still no locale, fallback to english
    if (!locale)
        return Constants_1.LocaleCode.en_us;
    // return found locale
    else
        return locale;
};
exports.getBrowserLocale = getBrowserLocale;
const formatDate = (date, options) => {
    var _a, _b, _c;
    const locale = (0, exports.getBrowserLocale)((_b = (_a = global === null || global === void 0 ? void 0 : global.window) === null || _a === void 0 ? void 0 : _a.navigator.language) !== null && _b !== void 0 ? _b : Constants_1.LocaleCode.en_us);
    return Intl.DateTimeFormat(locale, Object.assign(Object.assign({}, options), { timeZone: (_c = options === null || options === void 0 ? void 0 : options.timeZone) !== null && _c !== void 0 ? _c : 'UTC' })).format((0, parseISO_1.default)(date));
};
exports.formatDate = formatDate;
/**
 * constructErrorMessaging will construct an ReactNode of the errors to render under inputs.
 * @param errors
 */
const constructErrorMessaging = (errors) => {
    if (!errors)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: { display: 'flex', flexDirection: 'column', width: 'fit-content' } }, { children: Array.isArray(errors) ? errors === null || errors === void 0 ? void 0 : errors.map((err, index) => (0, jsx_runtime_1.jsx)("p", { children: err }, index)) : (0, jsx_runtime_1.jsx)("p", { children: errors }) })));
};
exports.constructErrorMessaging = constructErrorMessaging;
/**
 * fallback when the keys on the details object are unknown, this method will return an array of errors messages
 * which are constructed via `key: error message`.
 * @param errorDetails
 */
const handleErrorDetails = (errorDetails) => {
    if (!errorDetails)
        return undefined;
    return Object.entries(errorDetails).map(([key, value]) => `${key}: ${value}`);
};
exports.handleErrorDetails = handleErrorDetails;
